import { Link, useLocation } from "react-router-dom";

type NavItem = {
  name: string;
  href: string;
  count?: number;
  alert?: boolean;
};

type NavSection = {
  title: string;
  items: NavItem[];
};

const sections: NavSection[] = [
  {
    title: "ホーム",
    items: [{ name: "ホーム", href: "/direct-recruiting-sample/home" }],
  },
  {
    title: "求人",
    items: [{ name: "求人一覧", href: "/direct-recruiting-sample/jobs" }],
  },
  {
    title: "スカウト",
    items: [
      { name: "候補者検索", href: "/direct-recruiting-sample" },
      { name: "保存した検索条件", href: "/direct-recruiting-sample/saved-searches", count: 5 },
      { name: "ターゲットリスト", href: "/direct-recruiting-sample/targets" },
      { name: "気になるリスト", href: "/direct-recruiting-sample/favorites" },
      { name: "スカウト送信履歴", href: "/direct-recruiting-sample/scout-history", alert: true },
      { name: "スカウトテンプレート", href: "/direct-recruiting-sample/scout-templates" },
    ],
  },
  {
    title: "選考",
    items: [
      { name: "進捗管理", href: "/direct-recruiting-sample/progress" },
      { name: "メッセージ", href: "/direct-recruiting-sample/messages" },
      { name: "採用決定", href: "/direct-recruiting-sample/decisions" },
      { name: "メッセージテンプレート", href: "/direct-recruiting-sample/message-templates" },
    ],
  },
  {
    title: "レポート",
    items: [{ name: "振り返りレポート", href: "/direct-recruiting-sample/reports" }],
  },
];

export function SampleSidebar() {
  const location = useLocation();

  const isActive = (href: string) => {
    if (href === "/direct-recruiting-sample") {
      return (
        location.pathname === "/direct-recruiting-sample" ||
        location.pathname.startsWith("/direct-recruiting-sample/results") ||
        location.pathname.startsWith("/direct-recruiting-sample/candidates/")
      );
    }
    return location.pathname.startsWith(href);
  };

  return (
    <aside className="fixed inset-y-0 left-0 flex w-[270px] flex-col overflow-y-auto border-gray-200 border-r bg-white">
      {/* ロゴ */}
      <div className="flex h-12 shrink-0 items-center border-gray-200 border-b px-4">
        <Link className="flex items-center" to="/direct-recruiting-sample">
          <span
            className="font-bold text-gray-900 tracking-tight"
            style={{ fontFamily: "serif", fontSize: "16px" }}
          >
            DIRECTRECRUIT
          </span>
        </Link>
      </div>

      {/* ナビゲーション */}
      <nav className="flex-1 py-2">
        {sections.map((section) => (
          <div key={section.title} className="mb-1">
            <div className="px-4 py-1.5 text-xs font-medium text-gray-400">{section.title}</div>
            <ul>
              {section.items.map((item) => {
                const active = isActive(item.href);
                return (
                  <li key={item.name}>
                    <Link
                      className={`flex items-center justify-between px-6 py-2 text-sm transition-colors ${
                        active
                          ? "font-medium text-orange-600"
                          : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                      }`}
                      to={item.href}
                    >
                      <span>{item.name}</span>
                      {item.count !== undefined ? (
                        <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-medium text-white">
                          {item.count}
                        </span>
                      ) : null}
                      {item.alert ? (
                        <span
                          className="flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white"
                          style={{ fontSize: "10px" }}
                        >
                          !
                        </span>
                      ) : null}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>

      {/* スカウト残数 */}
      <div className="shrink-0 border-gray-200 border-t p-4">
        <div className="flex items-baseline justify-between">
          <span className="text-xs text-gray-500">残りスカウト通数</span>
          <span className="font-bold text-gray-900 text-lg">
            127<span className="font-normal text-gray-400 text-xs">通</span>
          </span>
        </div>
        <div className="mt-1.5 h-1.5 w-full rounded-full bg-gray-100">
          <div className="h-1.5 rounded-full bg-orange-500" style={{ width: "63%" }} />
        </div>
      </div>
    </aside>
  );
}
